<template src="./index.html" />

<script>
import {
  BButton,
  BCol,
  BRow,
  BForm,
  BBreadcrumb,
  BCard,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  VBTooltip,
  ModalPlugin,
  BButtonGroup,
  BOverlay, BImg, BModal,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import vSelect from 'vue-select'
import { STUDENT_CLASS_STATUSES } from '@/const/status'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-good-table.scss'
import { getUser } from '@/auth/utils'
import { OrganizationCode, PermissionCode, ResourceCode } from '@/const/code'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import CurriculumVitae from '@/views/curriculum-vitae/CurriculumVitae.vue'

export default {
  name: 'SearchStudent',
  components: {
    BImg,
    VueGoodTable,
    BButton,
    BCol,
    BRow,
    BForm,
    BBreadcrumb,
    BCard,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    ModalPlugin,
    VBTooltip,
    vSelect,
    BButtonGroup,
    BOverlay,
    BModal,
    CurriculumVitae,
  },
  props: {},
  data() {
    return {
      loading: false,
      user: getUser(),
      serverParams: {
        columnFilters: {},
        filterSearch: {
          trainingSystemId: '',
          courseId: '',
          classId: '',
          departmentId: '',
          majorId: '',
          consultantId: '',
          status: 1,
          name: '',
          code: '',
          type: null,
        },
        sort: [
          {
            field: '',
            type: '',
          },
        ],
        page: 1,
        perPage: 10,
      },
      studentId: null,
      classId: null,
      table: {
        fields: [
          {
            field: 'code',
            label: 'Mã sinh viên',
            sortable: false,
            type: 'string',
          },
          {
            field: 'name', label: 'Tên sinh viên', sortable: true, type: 'string',
          },
          {
            field: 'className',
            label: 'Lớp cố định',
            sortable: false,
            type: 'string',
          },
          {
            field: 'courseName', label: 'Khóa học', sortable: false, type: 'string',
          },
          {
            field: 'majorName', label: 'Ngành học', sortable: false, type: 'string',
          },
          {
            field: 'consultantName', label: 'Cố vấn học tập', sortable: false, type: 'string',
          },
          {
            field: 'status', label: 'Trạng thái', sortable: false, tdClass: 'text-center', thClass: ' text-center',
          },
          {
            field: 'action', label: '', sortable: false, tdClass: 'text-center',
          },
        ],
        items: [],
        totalRows: 0,
      },
      dataSendClass: {},
      optMajor: [],
      optStatus: [],
    }
  },
  computed: {
    ...mapGetters({
      classes: 'dropdown/classes',
      total: 'studentClass/totalRows',
      statuses: 'classes/statuses',
      majors: 'dropdown/majors',
      trainingSystems: 'dropdown/trainingSystems',
      courses: 'dropdown/courses',
      departments: 'dropdown/departments',
      teachers: 'dropdown/teachers',
      dataLists: 'studentClass/dataLists',
    }),
    provisionScoreExportable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.READ, ResourceCode.PROVISION_SCORE)
    },
    isDSU() {
      return this.user.orgCode === OrganizationCode.DSU
    },
    trainingSystemLabel() {
      return getUser().orgCode === OrganizationCode.HLUV ? 'Hệ đào tạo' : 'Hình thức đào tạo'
    },
  },
  async created() {
    // init data FROM API
    this.optStatus = STUDENT_CLASS_STATUSES
    await this.getInitData()
    // await this.getData(this.serverParams)
  },
  methods: {
    ...mapActions({
      readMajors: 'dropdown/getMajors',
      getTrainingSystem: 'dropdown/getTrainingSystems',
      getCourse: 'dropdown/getCourses',
      getDepartments: 'dropdown/getDepartments',
      getTeachers: 'dropdown/getTeachers',
      getClasses: 'dropdown/getClasses',
      searchStudent: 'studentClass/searchStudent',
      exportProvisionScorePdf: 'studentClass/exportProvisionScorePdf',
      exportWordConfirmStudent: 'studentClass/exportWordConfirmStudent',
      downloadStudents: 'studentClass/downloadStudents',
    }),

    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },

    onSortChange(params) {
      this.updateParams({
        sort: [
          {
            type: params[0].type,
            field: params[0].field,
          },
        ],
      })
      this.loadItems()
    },

    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },

    // load items is what brings back the rows from server
    loadItems() {
      this.btnSearchClick()
    },

    showToast(title, icon, variant, text) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title,
          icon,
          variant,
          text,
        },
      })
    },

    async btnSearchClick() {
      this.loading = true
      await this.getData(this.serverParams)
    },

    openModal() {
      this.dataSendClass = {}
      this.$refs['modal-class'].show()
    },

    async exportExcel(type) {
      this.serverParams.filterSearch.type = type
      const data = await this.downloadStudents(this.serverParams.filterSearch)
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'danh_sach_sinh_vien.xls')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    async exportPdf(type) {
      this.serverParams.filterSearch.type = type
      const data = await this.downloadStudents(this.serverParams.filterSearch)
      const url = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }))
      window.open(url, '_blank')
    },
    columnFilterFn() {},

    // getStatusName(id) {
    //   return STATUSES.find(status => status.value === id).label
    // },

    async getInitData() {
      await this.getTrainingSystem({ organizationId: this.user.orgId })
      await this.getDepartments({ organizationId: this.user.orgId })
    },

    async onChangeTrainingSystem(id) {
      this.serverParams.filterSearch.courseId = ''
      this.serverParams.filterSearch.classId = ''
      await this.getCourse({ trainingSystemId: id })
    },

    async onChangeDepartment(id) {
      this.serverParams.filterSearch.majorId = ''
      this.serverParams.filterSearch.teacherId = ''
      await this.readMajors({ departmentId: id })
      await this.getTeachers({ departmentId: id })
    },
    async onChangeCourse(id) {
      this.serverParams.filterSearch.classId = ''
      await this.getClasses({
        majorId: this.serverParams.filterSearch.majorId,
        courseId: id,
      })
    },

    async onChangeMajor(id) {
      this.serverParams.filterSearch.classId = ''
      await this.getClasses({
        majorId: id,
        courseId: this.serverParams.filterSearch.courseId,
      })
    },

    async getData(params) {
      this.loading = true
      try {
        await this.searchStudent({
          currentPage: params.page,
          itemsPerPage: params.perPage,
          trainingSystemId: params.filterSearch.trainingSystemId,
          courseId: params.filterSearch.courseId,
          departmentId: params.filterSearch.departmentId,
          majorId: params.filterSearch.majorId,
          status: params.filterSearch.status,
          classId: params.filterSearch.classId,
          orgId: this.user.orgId,
          name: params.filterSearch.name,
          code: params.filterSearch.code,
          consultantId: params.filterSearch.consultantId,
        })
        this.table.items = this.dataLists
        this.table.totalRows = this.total
      } catch (e) {
        this.showToast(`[${e.code}] ${e.message}`, 'XCircleIcon', 'danger')
      } finally {
        this.loading = false
      }
    },
    getTextStatus(id) {
      return STUDENT_CLASS_STATUSES.find(e => e.value === id).label
    },
    async onExportProvisionScorePdf(student) {
      this.loading = true
      try {
        const data = await this.exportProvisionScorePdf({ studentClassId: student.studentClassId })
        if (data) {
          const url = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }))
          window.open(url, '_blank')
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'File không có dữ liệu',
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        }
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.loading = false
      }
    },

    async onExportConfirmStudentWord(student) {
      this.loading = true
      try {
        const data = await this.exportWordConfirmStudent({ studentId: student.id })
        if (data) {
          const url = window.URL.createObjectURL(new Blob([data]), { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' })
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'XacNhanSv.docx')

          // Simulate click on the link to trigger the download
          document.body.appendChild(link)
          link.click()
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'File không có dữ liệu',
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        }
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.loading = false
      }
    },
    onInfoData(mainData) {
      this.studentId = mainData.id
      this.classId = mainData.classId
      this.$refs['modal-info-student'].show()
    },
  },
}
</script>
<style>
.v-select.drop-up.vs--open .vs__dropdown-toggle {
  border-radius: 0 0 4px 4px;
  border-top-color: transparent;
  border-bottom-color: rgba(60, 60, 60, 0.26);
}

[data-popper-placement="top"] {
  border-radius: 4px 4px 0 0;
  border-top-style: solid;
  border-bottom-style: none;
  box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
